import { isEmpty } from 'lodash';
import firebase from 'firebase/app';
import { db } from '@/vars/firebase';

export const checkField = (tempField, consoleError) => {
  const field = tempField[0];

  if (field.length > 15) {
    consoleError.push('cannot add extra column in this document');
  }
  if (field[0] !== 'id') {
    consoleError.push('The first column should be id');
  }
  if (field[1] !== 'fullName') {
    consoleError.push('The second column should be fullName');
  }
  if (field[2] !== 'cardNumber') {
    consoleError.push('The third column should be cardNumber');
  }
  if (field[3] !== 'employeeNumber') {
    consoleError.push('The forth column should be employeeNumber');
  }
  if (field[4] !== 'credit') {
    consoleError.push('The fifth column should be credit');
  }
  if (field[5] !== 'recurringCredit') {
    consoleError.push('The fifth column should be recurring credit');
  }
  if (field[6] !== 'type.id') {
    consoleError.push('The sixth column should be type.id');
  }
  if (field[7] !== 'type.name') {
    consoleError.push('The seventh column should be type.name');
  }
  if (field[8] !== 'email') {
    consoleError.push('The eighth column should be email');
  }
  if (field[9] !== 'mobile') {
    consoleError.push('The nineth column should be mobile');
  }
  if (field[10] !== 'isActive') {
    consoleError.push('The tenth column should be isActive');
  }
  if (field[11] !== 'createdAt') {
    consoleError.push('The forth column should be createdAt');
  }
  if (field[12] !== 'updatedAt') {
    consoleError.push('The thirteenth column should be updatedAt');
  }
  if (field[13] !== 'recurringCreditType') {
    consoleError.push('The fourteenth column should be recurringCreditType');
  }
  if (field[14] !== 'costCenter') {
    consoleError.push('The fifteenth column should be costCenter');
  }
  return consoleError;
};

export const randomIdMaker = () => {
  const length = 28;
  var result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const convert2string = errors => {
  let messages = '';
  errors.map(error => {
    messages += error + ';';
  });
  return messages;
};

export const csv2json = async (clientId, tempResult, consoleError) => {
  let jsonObjectId = [];
  let jsonObjectArray = [];
  let jsonObject = {};
  let count = 2;

  const companyId = await getCompanyId(clientId);
  const employeeTypeList = await getEmployeeType(companyId);

  tempResult.forEach(result => {
    const checkName = name => {
      if (isEmpty(name)) {
        consoleError.push(`row ${count} column B: name cannot left empty`);
        return '';
      } else return name;
    };

    const checkCard = cardNumber => {
      if (isEmpty(cardNumber)) {
        consoleError.push(`row ${count} column C: card number cannot left empty`);
        return '';
      } else if (isNaN(cardNumber)) {
        consoleError.push(`row ${count} column C: card number can only contain digits`);
        return '';
      } else return cardNumber;
    };

    const generatedTimeStamp = () => {
      return firebase.firestore.FieldValue.serverTimestamp();
    };

    const checkCredit = credit => {
      if (isEmpty(credit)) {
        consoleError.push('row ' + count + ' column E: credit should not be empty');
        return '';
      } else if (isNaN(credit)) {
        consoleError.push('row ' + count + ' column E: credit should be all digits');
        return '';
      } else {
        return Number(credit);
      }
    };

    const checkRecurringCredit = recurringCredit => {
      if (isNaN(recurringCredit)) {
        consoleError.push('row ' + count + ' column F: Recurring credit should be all digits');
        return '';
      } else {
        return Number(recurringCredit);
      }
    };

    const checkTypeId = (typeId, typeName) => {
      if (!isEmpty(typeId)) return typeId;
      // if check like this, then the type name should be unique.
      const idFirestore = employeeTypeList.find(employee => employee.type_name === typeName);
      if (!idFirestore) consoleError.push('row ' + count + ' column G: type.id not found.');
      return idFirestore ? idFirestore.type_id : '';
    };

    const checkTypeName = typeName => {
      if (!isEmpty(typeName)) return typeName;
      consoleError.push('row ' + count + ' column H: type.name cannot be empty.');
      return '';
    };

    for (let i = 0; i < result.length; i++) {
      if (result[i]) {
        jsonObject = {
          fullName: checkName(result[1]),
          cardNumber: checkCard(result[2]),
          employeeNumber: result[3],
          credit: checkCredit(result[4]),
          recurringCredit: checkRecurringCredit(result[5]),
          client: companyId,
          type: {
            id: checkTypeId(result[6], result[7]),
            name: checkTypeName(result[7]),
          },
          email: result[8],
          mobile: result[9],
          isActive: true,
          updatedAt: generatedTimeStamp(),
          recurringCreditType: result[13],
          costCenter: result[14],
        };
        //one array store the id
        jsonObjectId.push(result[0].toString());
        //one array store the object
        jsonObjectArray.push(jsonObject);
        break;
      }
    }
    count++;
  });
  return [jsonObjectId, jsonObjectArray, consoleError];
};

const getEmployeeType = async companyId => {
  var employeeTypeRef = db.collection('employeeTypes');
  if (companyId != null) employeeTypeRef = employeeTypeRef.where('client', '==', companyId);
  const employeeSnapshots = await employeeTypeRef.get();
  const datas = employeeSnapshots.docs.map(doc => {
    const data = doc.data();
    return { type_id: doc.id, type_name: data.name };
  });
  return datas;
};

export const getCompanyId = async clientid => {
  let companyId = null;
  await db
    .collection('users')
    .doc(clientid)
    .get()
    .then(async snapshot => {
      companyId = await snapshot.data().client.id;
    });
  return companyId;
};